/**
 * Helpers compartidos para las preferencias del traslado (tramos ida / vuelta).
 *
 * El producto de traslado viaja con:
 *  - `preferences.ida` / `preferences.vuelta`: las preferencias de cada tramo.
 *  - `modality` / `category` / `vehicles` (raíz): campos legacy que lee el
 *    backend para filtrar. Se calculan como unión de ambos tramos.
 */

/** Union de dos listas de preferencias, sin duplicados ni nulls. */
export function unionPreference(...lists: any[]): any[] {
  const result: any[] = [];
  lists.forEach(list => (list || []).forEach((item: any) => {
    if (item !== null && item !== undefined && !result.includes(item)) result.push(item);
  }));
  return result;
}

/** Normaliza un grupo de preferencias de un tramo. */
export function transferLegPayload(leg: any): {
  modality: any[];
  category: any[];
  vehicles: any[];
} {
  return {
    modality: leg?.modality || [],
    category: leg?.category || [],
    vehicles: leg?.vehicles || []
  };
}

/**
 * Arma el objeto `preferences` del producto de traslado.
 * El tramo "vuelta" sólo viaja si el traslado es ida y vuelta.
 */
export function buildTransferPreferences(preferences: any, hasReturn: boolean): any {
  const payload: any = { ida: transferLegPayload(preferences?.ida) };
  if (hasReturn) {
    payload.vuelta = transferLegPayload(preferences?.vuelta);
  }
  return payload;
}
